type ValueCategory = 'inline' | 'empty' | 'text';

const INLINE_MAX_LENGTH = 15;

export const categorizeDataValue = (value: unknown): ValueCategory => {
  if (value === null || value === undefined || value === '') {
    return 'empty';
  }

  if (typeof value === 'boolean' || typeof value === 'number') {
    return 'inline';
  }

  if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
    return 'text';
  }

  if (typeof value === 'string') {
    if (value.length <= INLINE_MAX_LENGTH) {
      return 'inline';
    }
  }

  return 'text';
};

export const formatInlineValue = (value: unknown): string => {
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }
  if (typeof value === 'number') {
    return String(value);
  }
  if (typeof value === 'string') {
    return value;
  }
  return String(value);
};

const isJsonString = (str: string): boolean => {
  const trimmed = str.trim();
  if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
    try {
      JSON.parse(str);
      return true;
    } catch {
      return false;
    }
  }
  return false;
};

export const formatTextValue = (value: unknown): string => {
  if (typeof value === 'object' && value !== null) {
    return JSON.stringify(value, null, 2);
  }

  if (typeof value === 'string') {
    if (isJsonString(value)) {
      try {
        const parsed = JSON.parse(value);
        return JSON.stringify(parsed, null, 2);
      } catch {
        return value;
      }
    }
    return value;
  }

  return String(value);
};
